import { createTheme } from '@mui/material/styles';

// Create a theme instance with better input field visibility
const theme = createTheme({
  palette: {
    primary: {
      main: '#3b82f6',
    },
    secondary: {
      main: '#10b981',
    },
    error: {
      main: '#ef4444',
    },
    background: {
      default: '#f9fafb',
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9ca3af',
            borderWidth: '2px',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3b82f6',
            borderWidth: '2px',
          },
        },
        notchedOutline: {
          borderColor: '#9ca3af',
          borderWidth: '2px',
        },
        input: {
          padding: '12px 14px',
          color: '#111827',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#4b5563',
          '&.Mui-focused': {
            color: '#3b82f6',
          },
        },
        outlined: {
          backgroundColor: 'rgba(249, 250, 251, 0.7)',
          padding: '0 4px',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          marginBottom: '16px',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: '4px',
          marginTop: '4px',
        },
      },
    },
  },
});

export default theme; 